import { request } from './common';

const host = window.configs.IMAGE_HOST;
const fieldKey = 'file';

// Client-side guard aligned with the svc-image upload limit.
export const MAX_SVC_IMAGE_UPLOAD_BYTES = 5 * 1024 * 1024;

export type UploadImageResponse =
  | {
      public_id?: string;
      result?: {
        id?: string;
        public_id?: string;
      };
      id?: string;
    }
  | undefined;

export function uploadImage(file, withId?): Promise<UploadImageResponse> {
  const url = withId ? `${host}/${withId}` : host;

  const formData = new FormData();
  formData.append(fieldKey, file);

  return request(url, {
    method: 'POST',
    body: formData,
  });
}

export function copyImage(id) {
  const formData = new FormData();
  formData.append(fieldKey, `${host}/${id}`);

  return request(host, {
    method: 'POST',
    body: formData,
  });
}

export function getUploadedImageId(response: UploadImageResponse) {
  return response?.public_id || response?.result?.public_id || response?.result?.id || response?.id;
}

export const ALLOWED_IMAGE_MIMETYPES = ['image/jpeg', 'image/png', 'image/svg+xml'];
